var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{staticClass:"status-icon",class:[ _vm.iconClass, {'inverted': _vm.inverted} ]},[_vm._v("\n  "+_vm._s(_vm.statusIcon)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }